import React, { Component } from "react";
import { Link as RouterLink } from "react-router-dom";
import { LOGIN } from "../_utils/routes";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { resetPassword } from "../_actions/authActions";
import TldrBase from "../TldrLogin/TldrBase";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Input,
  Link,
} from "@chakra-ui/react";
import { FaArrowLeft } from "react-icons/fa";
import { withTranslation } from "react-i18next";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formErrors: { email: "" },
      email: "",
      emailValid: false,
      formValid: false,
      loading: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e) {
    this.validateField(e.target.name, e.target.value);
    this.setState({ [e.target.name]: e.target.value });
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;

    switch (fieldName) {
      case "email":
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid
          ? ""
          : this.props.t("forgot_password.email_error");
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        emailValid: emailValid,
      },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({
      formValid: this.state.emailValid,
    });
  }

  onSubmit(e) {
    e.preventDefault();

    this.setState({ loading: true });
    const userData = {
      email: this.state.email,
    };

    this.props.resetPassword(userData, { ...this.props });
  }

  render() {
    const { t } = this.props;
    return (
      <TldrBase
        heading={t("forgot_password.heading")}
        subheading={t("forgot_password.subheading")}
      >
        <form onSubmit={this.onSubmit}>
          <FormControl my={3} isInvalid={this.state.formErrors.email}>
            <Input
              fontSize={"inherit"}
              size={"lg"}
              type="email"
              placeholder={t("forgot_password.email")}
              name="email"
              value={this.state.email}
              onChange={this.onChange}
            />
            <FormErrorMessage mb={3}>
              {this.state.formErrors.email}
            </FormErrorMessage>
          </FormControl>

          <Box mb={3}>
            <Button
              type="submit"
              isLoading={this.state.loading}
              variant="solid"
              isFullWidth
              size="lg"
              disabled={!this.state.formValid}
            >
              {t("forgot_password.reset")}
            </Button>
          </Box>
        </form>
        <Flex pt={8} justify="flex-end">
          <Link
            as={RouterLink}
            to={LOGIN}
            display="flex"
            alignItems="center"
            gap="2px"
          >
            <FaArrowLeft />
            {t("forgot_password.back")}
          </Link>
        </Flex>
      </TldrBase>
    );
  }
}

ForgotPassword.propTypes = {
  resetPassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { resetPassword })(
  withTranslation(["auth"])(ForgotPassword)
);
